<template>
  <div class="teste">Teste router</div>
</template>

<script>
export default {};
</script>

<style></style>
